import './anexos-tiss-controller';
import './anexos-tiss-item-quimio-controller';
import './anexos-tiss-item-opme-controller';